module.exports = __webpack_public_path__ + "static/media/dog_ate_404.296bde98.png";